<ng-content select="[appMenuGatilho]"></ng-content>
@if (aberto()) {
    <div
        [id]="idPainel"
        role="menu"
        [attr.aria-label]="rotulo()"
        [class]="classesPainel()"
        (keydown)="aoTeclar($event)">
        <ng-content></ng-content>
    </div>
}
